<template>
  <div>
    <MessageContainer
      :title="'sentMail'"
      :messages="messages"
      :icon="'envelope-open'"
    />
    <ComposeModal v-if="showComposeModal" @close="closeModal" />
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :sizeList="sizeList"
      v-if="messages && messages.length"
      @setPage="setPage"
      @setSize="setSize"
    />
    <FooterComponent />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import MessageContainer from "@/components/messages/MessageConatiner";
import ComposeModal from "@/components/messages/ComposeModal";
import FooterComponent from "@/components/Footer";
import Pagination from "@/components/Pagination";

export default {
  name: "sentMail",
  components: {
    MessageContainer,
    ComposeModal,
    FooterComponent,
    Pagination,
  },
  computed: {
    ...mapState(["showComposeModal", "dataUrl", "teacherData"]),
  },
  data() {
    return {
      messages: [],
      currentPage: 0,
      totalPages: null,
      sizeList: 10,
    };
  },
  methods: {
    ...mapMutations(["toggleComposeModal"]),
    setPage(page) {
      this.currentPage = page;
      this.getMessage();
    },
    setSize(size) {
      this.sizeList = size;
      this.currentPage = 0;
      this.getMessage();
    },
    async getMessage() {
      this.messages = [];
      let loader = this.$loading.show();
      let apiUrl = `${this.dataUrl}/message/getSentMessages?userId=${this.teacherData.id}&pageNumber=${this.currentPage}&pageSize=${this.sizeList}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        if (data.status.name.toLocaleLowerCase() === "ok") {
          this.messages = data.content.content.map(m => m.message);
            console.log(this.messages)
          this.totalPages = data.content.totalPages;
        }
      } catch {
        this.$notify({
          title: ["Ocurrio un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
    closeModal(reload) {
      this.toggleComposeModal(false);
      if (reload) {
        this.currentPage = 0;
        this.sizeList = 10;
        this.getMessage();
      }
    },
  },
  mounted() {
    this.getMessage();
  },
};
</script>
